import React, { useState, Fragment } from "react";
import SectionBezel from "components/SectionBezel";
import CheckoutAttributeToggle from "components/CheckoutAttributeToggle";
import {
  CHECKOUT_SESSION,
  VIRTUAL_CHECKOUT_SESSION
} from "utils/constants/stripe";
import { getCheckoutAttributesConfig } from "utils/checkout/attributes";
import { useShortLinkShipping } from "utils/hooks/shortLink";
import ShippingWorldwideToggle from "./ShippingWorldwideToggle";
import ShippingWorldwideSummary from "./ShippingWorldwideSummary";
import ShippingCountriesSelect from "./ShippingCountriesSelect";
import ShippingOptionsSummary from "./ShippingOptionsSummary";
import ShippingOptionsSelect from "./ShippingOptionsSelect";
import ShippingDestinationsSummary from "./ShippingDestinationsSummary";

const NODE_KEYS = {
  INHERITED_WORLDWIDE: "inherited-worldwide",
  INHERITED_DESTINATIONS: "inherited-destinations",
  INHERITED_OPTIONS: "inherited-options",
  DESTINATIONS: "destinations",
  OPTIONS: "options"
};

const ShippingFields = ({ name, inherited }) => {
  const [open, setOpen] = useState(false);

  const {
    // Values
    countryOptions,
    countrySelections,
    hasOptions,
    shippingWorldwideActive,
    // Inheritence
    inheritedSelections,
    preparedInheritedOptions,
    shippingWorldwideInheritedValue,
    activeDestinationsInheritence,
    hasDefinedShippingWorldwideInheritedValue,
    hasDefinedCountriesInheritedValue,
    activeShippingOptionsInheritence
  } = useShortLinkShipping({
    name,
    inherited
  });

  const toggleProps = {
    attributes: getCheckoutAttributesConfig({
      name,
      attributes: [
        CHECKOUT_SESSION.SHIPPING_ADDRESS_COLLECTION,
        CHECKOUT_SESSION.SHIPPING_OPTIONS,
        VIRTUAL_CHECKOUT_SESSION.SHIPPING_WORLDWIDE
      ]
    }),
    open,
    onChange: (updatedOpen) => updatedOpen && setOpen(updatedOpen)
  };

  let nodes = [];
  if (activeDestinationsInheritence) {
    if (hasDefinedShippingWorldwideInheritedValue) {
      nodes.push({
        key: NODE_KEYS.INHERITED_WORLDWIDE,
        node: (
          <ShippingWorldwideSummary
            active={Boolean(shippingWorldwideInheritedValue)}
          />
        )
      });
    } else if (hasDefinedCountriesInheritedValue) {
      nodes.push({
        key: NODE_KEYS.INHERITED_DESTINATIONS,
        node: <ShippingDestinationsSummary selections={inheritedSelections} />
      });
    }
  } else {
    nodes.push({
      key: NODE_KEYS.DESTINATIONS,
      node: (
        <Fragment>
          <label className="f5 fw6 db">Destinations</label>
          <ShippingWorldwideToggle
            name={name}
            active={shippingWorldwideActive}
          />
          {!shippingWorldwideActive && (
            <ShippingCountriesSelect
              shippingWorldwideActive={shippingWorldwideActive}
              options={countryOptions}
              selections={countrySelections}
              name={name}
            />
          )}
        </Fragment>
      )
    });
  }

  if (activeShippingOptionsInheritence) {
    nodes.push({
      key: NODE_KEYS.INHERITED_OPTIONS,
      node: (
        <ShippingOptionsSummary
          options={preparedInheritedOptions}
          hasDestinationsSummary={
            shippingWorldwideInheritedValue || inheritedSelections
          }
        />
      )
    });
  } else {
    nodes.push({
      key: NODE_KEYS.OPTIONS,
      node: <ShippingOptionsSelect name={name} hasOptions={hasOptions} />
    });
  }

  return (
    <SectionBezel
      header="Shipping"
      action={<CheckoutAttributeToggle {...toggleProps} />}
      expandable
      isOpen={open}
      setOpen={setOpen}
    >
      {nodes.map(({ node, key }) => (
        <div key={key} className="w-100">
          {node}
        </div>
      ))}
    </SectionBezel>
  );
};

export default ShippingFields;
